import ModalSummerize from './ModalSummerize'
export default ModalSummerize
